module.exports = __webpack_public_path__ + "app/assets/images/footer-arrow.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/footer-arrow.png
// module id = 1122
// module chunks = 7